import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Inject,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TuiAvatarModule } from '@taiga-ui/kit';
import {
  TuiButtonModule,
  TuiDataListModule,
  TuiHostedDropdownModule,
  TuiSvgModule,
} from '@taiga-ui/core';
import { AuthState } from '@store/auth/auth.state';
import { Store } from '@ngxs/store';
import { tuiIconChevronDown } from '@taiga-ui/icons';
import { WINDOW } from '@shared/providers/window.provider';
import { DROPDOWN_MENU_ITEMS, MenuItem } from '../../menu';
import { OrganizationRouteNames } from '../../../../route-names';
import { SUPER_ADMINS } from '../../../../types/auth';

@Component({
  selector: 'app-dropdown-menu',
  standalone: true,
  imports: [
    RouterLink,
    TuiAvatarModule,
    TuiDataListModule,
    TuiHostedDropdownModule,
    TuiSvgModule,
    TuiButtonModule,
  ],
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent {
  isAuthenticated = this.store.selectSignal(AuthState.isAuthenticated);
  isGreenlandUser = this.store.selectSignal(AuthState.isGreenlandUser);
  user = this.store.selectSignal(AuthState.getUser);
  availableMenuItems = computed(() => {
    const superAdmin = SUPER_ADMINS.includes(this.user()?.email ?? '');
    const isGreenlandUser = this.isGreenlandUser();
    const isAuthenticated = this.isAuthenticated();
    return DROPDOWN_MENU_ITEMS.filter(menuItem => {
      if (menuItem?.authenticated) {
        return isAuthenticated;
      }
      return true;
    })
      .filter(menuItem => (menuItem.greenland ? isGreenlandUser : true))
      .filter(menuItem => {
        return !!(superAdmin || !menuItem.roles?.length);
      });
  });

  protected readonly tuiIconChevronDown = tuiIconChevronDown;
  constructor(
    @Inject(WINDOW) private readonly window: Window,
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  navigate(route: MenuItem) {
    if (route.path === OrganizationRouteNames.DETAILS) {
      const divisionId = this.store.selectSnapshot(
        AuthState.getUserActiveDivision,
      );
      if (divisionId) {
        const path = route.path.replace(':id', divisionId.toString());
        return this.router.navigate([path]);
      }
      return;
    }
    return route.blank
      ? this.window.open(route.path, '_blank')
      : this.router.navigate([route.path]);
  }
}
